import styled from "styled-components"
// import Image from "../../../assets/logo mark  gradient 1.svg";

const Info = () => {
    return (
        <Wrapper>
            <div>
                <div>
                    <h2>Our Vision</h2>
                    <p>To be a financially viable community that is committed to satisfying customer’s needs by offering diverse investment offers that are technologically driven</p>
                </div>
                <div>
                    <h2>Our Mission</h2>
                    <p>To provide positive investment opportunities for all our clients. <br />
                        To create and maintain a professional environment that fosters the confidence of all stakeholders. <br />
                        To embrace technology as a means to providing lasting investment solutions.</p>
                </div>
            </div>
            {/* <ImgBackground>
                <img  src={Image} alt="bannerImage" />
            </ImgBackground> */}
        </Wrapper>
    )
}

export default Info


export const Wrapper = styled.div`
  background-image: url("https://res.cloudinary.com/dvwbbiu0g/image/upload/v1652353267/invest-trust/blue_Opaque_shield_logo_lgommu.png");
  background-position: right;
  background-repeat: no-repeat;

  div:nth-of-type(1) h2 {
    text-align: center;
    font-size: 2rem;
    color: ${({ theme }) => theme.colors.body};
  }
  div:nth-of-type(1) p {
    text-align: center;
    font-size: 1.25rem;
    width: 36rem;
    margin: auto;
  }
  div:nth-of-type(2) h2 {
    padding-top: 4rem;
    text-align: center;
    font-size: 2rem;
    color: ${({ theme }) => theme.colors.body};
  }
  div:nth-of-type(2) p {
    text-align: center;
    font-size: 1.25rem;
    width: 37.5rem;
    margin: auto;
    padding-bottom: 5rem;
  }

  @media screen and (max-width: 991px) {
    background-position: center;
    div:nth-of-type(1) h2 {
      text-align: center;
      font-size: 2rem;
      color: ${({ theme }) => theme.colors.body};
    }
    div:nth-of-type(1) p {
      text-align: center;
      font-size: 1.25rem;
      width: 36rem;
      margin: auto;
    }
    div:nth-of-type(2) h2 {
      padding-top: 5rem;
      text-align: center;
      font-size: 2rem;
      color: ${({ theme }) => theme.colors.body};
    }
    div:nth-of-type(2) p {
      text-align: center;
      font-size: 1.25rem;
      width: 37.5rem;
      margin: auto;
      padding-bottom: 5rem;
    }
  }
  @media screen and (max-width: 579px) {
    div:nth-of-type(1) h2 {
      text-align: center;
      font-size: 2rem;
      color: ${({ theme }) => theme.colors.body};
    }
    div:nth-of-type(1) p {
      text-align: center;
      font-size: 1.25rem;
      width: 90%;
      //   margin: auto;
      margin-bottom: 0rem;
    }
    div:nth-of-type(2) h2 {
      margin-top: 0rem;
      padding-top: 5rem;
      text-align: center;
      font-size: 2rem;
      color: ${({ theme }) => theme.colors.body};
    }
    div:nth-of-type(2) p {
      text-align: center;
      font-size: 1.25rem;
      width: 90%;
      padding-bottom: 5rem;
    }
  }
`;
export const ImgBackground = styled.div`
    // position: relative;
    display: flex;
    justify-content: flex-end;
    // margin-top: -5rem;
    // transform: translateY(-15rem);
    border: 3px solid teal;
    top: 5rem;
    
    // img {
    //     color: red;
    // }
`